
/**
 * 구독 상태
 */
export type GetSubscriptionByOrder200SubscriptionStatus = typeof GetSubscriptionByOrder200SubscriptionStatus[keyof typeof GetSubscriptionByOrder200SubscriptionStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetSubscriptionByOrder200SubscriptionStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  CANCELLED: 'CANCELLED',
  EXPIRED: 'EXPIRED',
} as const;
